import {
  ProductsNewAccounting,
  ProductsNewGeneral,
  ProductsNewOthers,
  ProductsNewProductCodes,
  ProductsNewVariants,
} from "../../layouts/data-panel/Products/new-product";
import {ProductMovementsGeneral} from "../../layouts/data-panel/Products/product-movements-new";
import {PriceListGeneral} from "../../layouts/data-panel/Products/product-pricelist-new";
import {SettingsMyData} from "../../layouts/data-panel/Settings-MyData";
import {
  AdvancedTypesNew,
  BasicTypesNew,
} from "../../layouts/data-panel/Settings-Document-Types";
import NewClientGeneral from "../../layouts/data-panel/Clients/new-client-general";
import NewSupplierGeneral from "../../layouts/data-panel/Suppliers/new-supplier-general";
import NewClientInstallations from "../../layouts/data-panel/Clients/new-client-installations";
import NewClientCommunicationHistory from "../../layouts/data-panel/Clients/new-client-communication-history";
import NewClientNotes from "../../layouts/data-panel/Clients/new-client-notes";
import NewClientEmron from "../../layouts/data-panel/Clients/new-client-emron";
import NewClientAccounting from "../../layouts/data-panel/Clients/new-client-accounting";
import ClientMovementsNew from "../../layouts/data-panel/Clients/client-movements-new";
import ClientsSettings, {ClientSettingsLog} from "../../layouts/data-panel/Clients/clients-settings";
import VatData from "../../layouts/data-panel/Settings-Data/VatData";
import PrimerDataOtherData from "../../layouts/data-panel/Settings-Data/PrimerDataOtherData";
import VatDataOtherTaxes from "../../layouts/data-panel/Settings-Data/VatDataOtherTaxes";
import VatDataOtherTaxes2 from "../../layouts/data-panel/Settings-Data/VatDataOtherTaxes2";
import LogTable from "../LogTable";
import SalesNew from "../../layouts/data-panel/Sales/sales-new";
import ClientPaymentsNew from "../../layouts/data-panel/Sales/client-payments-new";
import {
  ProductsEditAccounting,
  ProductsEditGeneral,
  ProductsEditLog,
  ProductsEditOthers,
  ProductsEditProductCodes,
  ProductsEditVariants,
} from "../../layouts/data-panel/Products/edit-product";
import CashRegistersNew from "../../layouts/data-panel/Cash/cash-registers-new";
import BankAccountNew from "../../layouts/data-panel/Cash/bank-accounts-new";
import PosNew from "../../layouts/data-panel/Cash/pos-new";
import SalesGeneralSettings, {SalesGeneralSettingsLog,} from "../../layouts/data-panel/Sales/sales-general-settings";
import {EditPriceListGeneral, PriceListEditLog} from "../../layouts/data-panel/Products/edit-product-price-list";
import {
  EditProductMovementsGeneral,
  ProductMovementsEditLog
} from "../../layouts/data-panel/Products/edit-product-movements";
import {
  EditAdvancedTypeLogTable,
  EditAdvancedTypes
} from "../../layouts/data-panel/Settings-Document-Types/edit-advanced-types";
import {EditBasicType, EditBasicTypeLogTable} from "../../layouts/data-panel/Settings-Document-Types/edit-basic-types";
import EditPos, {PosEditLog} from "../../layouts/data-panel/Cash/edit-pos";
import EditBankAccounts, {BankEditLog} from "../../layouts/data-panel/Cash/edit-bank-accounts";
import EditCashRegisters, {CashEditLog} from "../../layouts/data-panel/Cash/edit-cash-registers";
import ViewSales, {SalesEditLog} from "../../layouts/data-panel/Sales/view-sales";
import SalesMydataReport from "../../layouts/data-panel/Sales/sales-mydata-report";
import EditClientGeneral, {ClientsEditLog} from "../../layouts/data-panel/Clients/Edit/edit-client-general";
import EditClientInstallations from "../../layouts/data-panel/Clients/Edit/edit-client-installations";
import EditClientCommunicationHistory from "../../layouts/data-panel/Clients/Edit/edit-client-communication-history";
import EditClientNotes from "../../layouts/data-panel/Clients/Edit/edit-client-notes";
import EditClientEmron from "../../layouts/data-panel/Clients/Edit/edit-client-emron";
import EditClientAccounting from "../../layouts/data-panel/Clients/Edit/edit-client-accounting";
import EditClientPayments, {ClientPaymentsEditLog} from "../../layouts/data-panel/Sales/edit-client-payments";
import NewSupplierInstallations from "../../layouts/data-panel/Suppliers/new-supplier-installations";
import NewSupplierCommunicationHistory from "../../layouts/data-panel/Suppliers/new-supplier-communication-history";
import NewSupplierAccounting from "../../layouts/data-panel/Suppliers/new-supplier-accounting";
import SuppliersSettings, {SupplierSettingsLog} from "../../layouts/data-panel/Suppliers/suppliers-settings";
import EditSupplierGeneral, {SuppliersEditLog} from "../../layouts/data-panel/Suppliers/Edit/edit-supplier-general";
import EditSupplierInstallations from "../../layouts/data-panel/Suppliers/Edit/edit-supplier-installations";
import EditSupplierCommunicationHistory
  from "../../layouts/data-panel/Suppliers/Edit/edit-supplier-communication-history";
import EditSupplierAccounting from "../../layouts/data-panel/Suppliers/Edit/edit-supplier-accounting";
import SupplierMovementsNew from "../../layouts/data-panel/Suppliers/supplier-movements-new";
import EditBuys, {BuysEditLog} from "../../layouts/data-panel/Buys/edit-buys";
import BuysNew from "../../layouts/data-panel/Buys/buys-new";
import SupplierPaymentsNew from "../../layouts/data-panel/Buys/supplier-payments-new";
import EditSupplierPayments, {SupplierPaymentsEditLog} from "../../layouts/data-panel/Buys/edit-supplier-payments";
import BuysGeneralSettings, {BuysGeneralSettingsLog} from "../../layouts/data-panel/Buys/buys-general-settings";
import EditClientMovements, {ClientMovementsEditLog} from "../../layouts/data-panel/Clients/Edit/edit-client-movements";
import EmronPayments from "../../layouts/data-panel/Clients/reports-emron-payments";
import NewEmployee from "../../layouts/data-panel/Payroll/new-employee";
import EditEmployee, {EmployeeEditLog} from "../../layouts/data-panel/Payroll/edit-employee";
import NewAccountingAccount from "../../layouts/data-panel/Accounting/new-accounting-acount";
import EditAccountingAccount, {
  AccountingAccountsEditLog
} from "../../layouts/data-panel/Accounting/edit-accounting-account";
import AccountingAccountEditMyData from "../../layouts/data-panel/Accounting/accounting-account-edit-mydata";
import AccountingAccountNewMyData from "../../layouts/data-panel/Accounting/accounting-account-new-mydata";
import {ImportLog, SettingsImport, SettingsOfImport} from "../../layouts/data-panel/Settings/settings-import";
import SettingsExport, {SettingsOfExport} from "../../layouts/data-panel/Settings/settings-export";
import {SettingsOfBackup} from "../../layouts/data-panel/Settings/settings-backup";
import {SettingsOfRestore} from "../../layouts/data-panel/Settings/settings-restore";
import {
  AccountingAccountSettings, AccountingF2DocumentRules, AccountingIncomeExpenseBookSettings,
  AccountingOperatingStatementRules,
  AccountingPaymentMethods,
  AccountingSettingsLog,
  AccountingYearReportSettings
} from "../../layouts/data-panel/Accounting/accounting-account-settings";
import {AccountingRecordSettings} from "../../layouts/data-panel/Accounting/accounting-record-settings";
import {
  AccountingRecordEditLog,
  EditAccountingRecord
} from "../../layouts/data-panel/Accounting/edit-accounting-record";
import EditSupplierMovements, {
  SupplierMovementsEditLog
} from "../../layouts/data-panel/Suppliers/Edit/edit-supplier-movements";
import SettingsSubscriptions from "../../layouts/data-panel/Settings/settings-subscriptions";
import EditClientSubscriptions from "../../layouts/data-panel/Clients/Edit/edit-client-subscriptions";
import ReportsClientsSubscriptions from "../../layouts/data-panel/Clients/reports-clients-subscriptions";
import BuysMydataReport from "../../layouts/data-panel/Buys/buys-mydata-report";
import {
  NewAdvancedTypesAccounting
} from "../../layouts/data-panel/Settings-Document-Types/new-advanced-types-accounting";
import {
  EditAdvancedTypesAccounting
} from "../../layouts/data-panel/Settings-Document-Types/edit-advanced-types-accounting";
import {CashSettingsAccounting, CashSettingsLog} from "../../layouts/data-panel/Cash/cash-settings-accounting";
import {PayrollSettings, PayrollSettingsLog} from "../../layouts/data-panel/Payroll/payroll-settings";
import EditWorkMovement, {WorkMovementEditLog} from "../../layouts/data-panel/Payroll/edit-work-movement";
import NewWorkMovement from "../../layouts/data-panel/Payroll/new-work-movement";
import NewWorkPermit from "../../layouts/data-panel/Payroll/new-work-permit";
import EditWorkPermit, {WorkPermitEditLog} from "../../layouts/data-panel/Payroll/edit-work-permit";
import AccountingClosure from "../../layouts/data-panel/Accounting/accounting-closure";
import PrescriptionSettings from "../../layouts/data-panel/Prescriptions/prescription-settings";
import VisitNew from "../../layouts/data-panel/Prescriptions/visit-new";
import VisitActive from "../../layouts/data-panel/Prescriptions/visit-active";
import VisitEdit from "../../layouts/data-panel/Prescriptions/visit-edit";
import PrescriptionEdit from "../../layouts/data-panel/Prescriptions/prescription-edit";
import ReferralEdit from "../../layouts/data-panel/Prescriptions/referral-edit";
import EditDcl, {DclEditLog} from "../../layouts/data-panel/dcl/edit-dcl";
import DclSettings from "../../layouts/data-panel/dcl/dcl-settings";
import EditClientCloud from "../../layouts/data-panel/Clients/Edit/edit-client-cloud";
import EditSupplierCloud from "../../layouts/data-panel/Suppliers/Edit/edit-supplier-cloud";
import NewAccountingRecord from "../../layouts/data-panel/Accounting/new-accounting-record";
import FixedAssetsSettings, {FixedAssetsSettingsLog} from "../../layouts/data-panel/FixedAssets/fixed-assets-settings";
import NewFixedAsset, {NewFixedAssetAccounting} from "../../layouts/data-panel/FixedAssets/new-fixed-asset";
import EditFixedAsset, {
  EditFixedAssetAccounting,
  EditFixedAssetLog
} from "../../layouts/data-panel/FixedAssets/edit-fixed-asset";
import NewFixedAssetMovement from "../../layouts/data-panel/FixedAssets/new-fixed-asset-movement";
import EditFixedAssetMovement, {
    EditFixedAssetMovementLog
} from "../../layouts/data-panel/FixedAssets/edit-fixed-asset-movement";
import NewFixedAssetRecord from "../../layouts/data-panel/FixedAssets/new-fixed-asset-record";
import EditFixedAssetRecord, {
    EditFixedAssetRecordLog
} from "../../layouts/data-panel/FixedAssets/edit-fixed-asset-record";
import ManageCompanies from "../../layouts/data-panel/ManageCompanies";
import QuotationsNew from "../../layouts/data-panel/Sales/quotations-new";
import QuotationsEdit, {QuotationsEditLog} from "../../layouts/data-panel/Sales/quotations-edit";
import AiUrlGenerator from "../../layouts/data-panel/Sales/sales-erp-ai-url";
import {ProductSettings, ProductSettingsLog} from "../../layouts/data-panel/Products/product-settings-new";
import CompanySettings from "../../layouts/data-panel/Settings/company-settings";
import SystemTasks from "../../layouts/data-panel/Settings/system-tasks";
import SettingsEmailSMTP from "../../layouts/data-panel/Settings/settings-email-smtp";
import ChequeNew from "../../layouts/data-panel/Cash/cheque-new";
import ChequeEdit, {ChequeEditLog} from "../../layouts/data-panel/Cash/cheque-edit";
import NewLoan from "../../layouts/data-panel/Cash/new-loan";
import EditLoan, {EditLoanLog} from "../../layouts/data-panel/Cash/edit-loan";
import CardsNew from "../../layouts/data-panel/Cash/cards-new";
import CardsEdit, {CardsEditLog} from "../../layouts/data-panel/Cash/cards-edit";

export const products_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'product',
  tabs: [
    { key:"products-new-general",
      tabNumber: 1,
      tabName: "ProductsNewGeneralTabs.general",
      tabData: <ProductsNewGeneral />,
      permission: "products-products/new-general-read",
    },
    {key:"products-new-otherTaxes",
      tabNumber: 2,
      tabName: "ProductsNewGeneralTabs.otherTaxes",
      tabData: <ProductsNewOthers />,
      permission: "products-products/new-othertaxes-read"
    },
    {key:"products-new-accounting",
      tabNumber: 3,
      tabName: "ProductsNewGeneralTabs.accounting",
      tabData: <ProductsNewAccounting />,
      permission: "products-products/new-accounting",
    },
    {key:"products-new-productCodes",
      tabNumber: 4,
      tabName: "ProductsNewGeneralTabs.tags",
      tabData: <ProductsNewProductCodes />,
      permission: "products-products/new-tags-read",
    },
    {key:"products-new-variants",
      tabNumber: 5,
      tabName: "ProductsNewGeneralTabs.variants",
      tabData: <ProductsNewVariants />,
      permission: "products-products/new-variants-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearBtn: false,
  clearForm: false,
  saveandrepeat: true,
  header: {
    headerNew: "Headings.newProduct",
    headerEdited: "New Product",
  },
}

export const edit_Product_DP_JSON = (tabKey) => {
  return {
    company: "company_name",
    templateEnable: true,
    templateType: 'editProduct',
    tabs: [
      {key:"products-new-general",
        tabNumber: 1,
        tabName: "ProductsNewGeneralEditTabs.general",
        tabData: <ProductsEditGeneral tabKey={tabKey} />,
        permission: "products-products/edit-general-read",
      },
      {key:"products-new-otherTaxes",
        tabNumber: 2,
        tabName: "ProductsNewGeneralEditTabs.otherTaxes",
        tabData: <ProductsEditOthers tabKey={tabKey} />,
        permission: "products-products/edit-othertaxes-read",
      },
      {key:"products-new-accounting",
        tabNumber: 3,
        tabName: "ProductsNewGeneralEditTabs.accounting",
        tabData: <ProductsEditAccounting tabKey={tabKey} />,
        permission: "products-products/edit-accounting-read",
      },
      {key:"products-new-productCodes",
        tabNumber: 4,
        tabName: "ProductsNewGeneralEditTabs.tags",
        tabData: <ProductsEditProductCodes tabKey={tabKey} />,
        permission: "products-products/edit-tags-read",
      },
      {key:"products-edit-variants",
        tabNumber: 5,
        tabName: "ProductsNewGeneralTabs.variants",
        tabData: <ProductsEditVariants tabKey={tabKey} />,
        permission: "products-products/edit-variants-read",
      },
      {key:"products-new-log",
        tabNumber: 6,
        tabName: "Log",
        tabData: <ProductsEditLog tabKey={tabKey} />,
        permission: "products-products/edit-read",
      },
    ],
    deleteBtn: true,
    saveBtn: true,
    clearBtn: false,
    clearForm: false,
    saveandrepeat: false,
    header: {
      headerNew: "Headings.editProduct",
      headerEdited: "Edit Product",
    },
  }
}

export const productsMovements_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'productMovements',
  tabs: [
    {key:"productMovements-new-general",
      tabNumber: 1,
      tabName: "ProductsMovementsNewTabs.general",
      tabData: <ProductMovementsGeneral />,
      permission: "products-productsmovements/new-general-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearBtn: false,
  clearForm: false,
  saveandrepeat: false,
  header: {
    headerNew: "Headings.newProductMovements",
    headerEdited: "New Product Movements",
  },
};

export const editProductsMovements_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'editProductMovements',
  tabs: [
    {key:"productMovements-new-general",
      tabNumber: 1,
      tabName: "ProductsMovementsNewTabs.general",
      tabData: <EditProductMovementsGeneral />,
      permission: "products-productsmovements/edit-general-read",
    },

    {key:"productMovements-new-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <ProductMovementsEditLog />,
      permission: "products-productsmovements/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearBtn: false,
  clearForm: false,
  saveandrepeat: false,
  header: {
    headerNew: "Headings.editProductMovements",
    headerEdited: "Edit Product Movements",
  },
}

export const pricelist_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'priceList',
  tabs: [
    {key:"products-priceList-new-general",
      tabNumber: 1,
      tabName: "ProductsListNewTabs.general",
      tabData: <PriceListGeneral />,
      permission: "products-pricelist/new-general-read"
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearBtn: false,
  clearForm: false,
  saveandrepeat: true,
  header: {
    headerNew: "Headings.newPriceList",
    headerEdited: "New Price List",
  },
};

export const editPricelist_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'editPriceList',
  tabs: [
    {key:"products-priceList-new-general",
      tabNumber: 1,
      tabName: "ProductsListNewTabs.general",
      tabData: <EditPriceListGeneral />,
      permission: "products-pricelist/edit-general-read"
    },

    {key:"products-priceList-new-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <PriceListEditLog />,
      permission: "products-pricelist/edit-read"
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearBtn: false,
  clearForm: false,
  saveandrepeat: false,
  header: {
    headerNew: "Headings.editPriceList",
    headerEdited: "Edit Price List",
  },
};

export const productSettings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'productCategory',
  tabs: [
    {key:"products-settings-productCategories-settings",
      tabNumber: 1,
      tabName: "ProductsSettingsTabs.settings",
      tabData: <ProductSettings />,
      permission: "products-settings/productcategories-read"
    },
    {key:"products-settings-productCategories-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <ProductSettingsLog />,
      permission: "products-settings/productcategories-read"
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Headings.productCategoriesSettings",
    headerEdited: "Product Categories Settings",
  },
}

export const accounting_account_settings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: "accountingAccountSettings",
  tabs: [
    {
      tabNumber: 1,
      tabName: "Settings",
      tabData: <AccountingAccountSettings />,
      permission: "accounting-settings/accounting-settings-read",
    },
    {
      tabNumber: 2,
      tabName: "Τρόποι πληρωμής",
      tabData: <AccountingPaymentMethods />,
      permission: "accounting-settings/accounting-paymentmethods-read",
    },
    {
      tabNumber: 3,
      tabName: "Κανόνες Ετησίων Αποτ.",
      tabData: <AccountingYearReportSettings />,
      permission: "accounting-settings/accounting-yearreportrules-read",
    },
    {
      tabNumber: 4,
      tabName: "Κανόνες Γεν. Εκμ.",
      tabData: <AccountingOperatingStatementRules />,
      permission: "accounting-settings/accounting-operatingstatementrules-read",
    },
    {
      tabNumber: 5,
      tabName: "Κανόνες Βιβλίου Εσ/Εξόδων",
      tabData: <AccountingIncomeExpenseBookSettings />,
      permission: "accounting-settings/accounting-iebookrules-read",
    },
    {
      tabNumber: 6,
      tabName: "Κανόνες Εντύπου Φ2",
      tabData: <AccountingF2DocumentRules />,
      permission: "accounting-forms/f2-write",
    },
    {
      tabNumber: 7,
      tabName: "Log",
      tabData: <AccountingSettingsLog />,
      permission: "accounting-settings/accounting-settings-read",
    }
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Ρυθμίσεις Προτύπων Λογαριασμών",
    headerEdited: "Accounting Settings",
  },
};

export const accounting_record_settings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {
      tabNumber: 1,
      tabName: "Settings",
      tabData: <AccountingRecordSettings />,
      permission: "accounting-settings/recordtemplates-settings-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Ρυθμίσεις Προτύπων Εγγραφής",
    headerEdited: "Accounting Record Settings",
  },
};


export const settingsPrimerMyData = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {key:"primer-my-data-vat",
      tabNumber: 1,
      tabName: "SettingPrimerMyDataTabs.setting",
      tabData: <SettingsMyData />,
      permission: "settings-primermydata/primermydata-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Headings.primerMyData",
    headerEdited: "Primer MyData",
  },
}

export const settingsPrimerData = {
  company: "company_name",
  templateEnable: false,
  templateType: 'settingsPrimeData',
  tabs: [
    {key:"primer-my-data-vat",
      tabNumber: 1,
      tabName: "SettingsPrimerDataTabs.vat",
      tabData: <VatData />,
      permission: "settings-primermydata/data-read",
    },
    {key:"primer-my-data-otherTaxes1",
      tabNumber: 2,
      tabName: "SettingsPrimerDataTabs.otherTaxes1",
      tabData: <VatDataOtherTaxes />,
      permission: "settings-primermydata/data-read",
    },
    {key:"primer-my-data-otherTaxes2",
      tabNumber: 3,
      tabName: "SettingsPrimerDataTabs.otherTaxes2",
      tabData: <VatDataOtherTaxes2 />,
      permission: "settings-primermydata/data-read",
    },
    {key:"primer-my-data-otherData",
      tabNumber: 4,
      tabName: "SettingsPrimerDataTabs.otherData",
      tabData: <PrimerDataOtherData />,
      permission: "settings-primermydata/data-read",
    },
    {key:"primer-my-data-log",
      tabNumber: 5,
      tabName: "Log",
      tabData: <LogTable logType="primerMyDataDataLog" />,
      permission: "settings-primermydata/data-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Headings.settingsPrimerData",
    headerEdited: "Settings Primer Data",
  },
};

export const settingsDocumentTypesBasicTypesNew = {
  company: "company_name",
  templateEnable: false,
  templateType: 'basicType',
  tabs: [
    {key:"basic-types-new-general",
      tabNumber: 1,
      tabName: "DocumentTypeBasicNewTabs.basicTypes",
      tabData: <BasicTypesNew />,
      permission: "settings-documenttype/basictypesnew-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearBtn: false,
  clearForm: false,
  header: {
    headerNew: "Headings.newBasicTypes",
    headerEdited: "New Basic Types",
  },
};

export const settingsDocumentTypesEditBasicTypes = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editBasicType',
  tabs: [
    {key:"basic-types-new-general",
      tabNumber: 1,
      tabName: "DocumentTypeBasicNewTabs.basicTypes",
      tabData: <EditBasicType />,
      permission: "settings-documenttype/basictypesedit-read",
    },

    {key:"basic-types-new-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <EditBasicTypeLogTable />,
      permission: "settings-documenttype/basictypesedit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearBtn: false,
  clearForm: false,
  header: {
    headerNew: "Headings.editBasicTypes",
    headerEdited: "Edit Basic Types",
  },
}

export const settingsDocumentTypesAdvancedTypesNew = {
  company: "company_name",
  templateEnable: false,
  templateType: 'advancedType',
  tabs: [
    {
      key:"advanced-types-new-general",
      tabNumber: 1,
      tabName: "DocumentTypeAdvancedNewTabs.advancedTypes",
      tabData: <AdvancedTypesNew />,
      permission: "settings-documenttype/advancedtypesnew-read",
    },
    {
      key: "advanced-types-new-accounting",
      tabNumber: 2,
      tabName: "Λογιστική",
      tabData: <NewAdvancedTypesAccounting />,
      permission: "settings-documenttype/advancedtypesnew-accounting-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Headings.newAdvancedType",
    headerEdited: "New Advanced Type",
  },
};

export const settingsDocumentTypesEditAdvancedTypes = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editAdvancedType',
  tabs: [
    {
      key:"advanced-types-new-general",
      tabNumber: 1,
      tabName: "DocumentTypeAdvancedNewTabs.advancedTypes",
      tabData: <EditAdvancedTypes />,
      permission: "settings-documenttype/advancedtypesedit-read",
    },
    {
      key: "advanced-types-edit-accounting",
      tabNumber: 2,
      tabName: "Λογιστική",
      tabData: <EditAdvancedTypesAccounting />,
      permission: "settings-documenttype/advancedtypesedit-accounting-read",
    },
    {
      key:"advanced-types-new-log",
      tabNumber: 3,
      tabName: "Log",
      tabData: <EditAdvancedTypeLogTable />,
      permission: "settings-documenttype/advancedtypesedit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Headings.editAdvancedType",
    headerEdited: "Edit Advanced Type",
  },
};

export const settingsGeneralSettingsCompanySettings = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {key:"company-settings-general",
      tabNumber: 1,
      tabName: "GeneralSettingsTabs.companySettings",
      tabData: <CompanySettings />,
      permission: "settings-generalsettings/companysettings-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Headings.companySettings",
    headerEdited: "Company Settings",
  },
};

export const settingsGeneralSettingsSystemTasks = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {key:"system-tasks-tasks",
      tabNumber: 1,
      tabName: "Εργασίες",
      tabData: <SystemTasks />,
      permission: "settings-generalsettings/systemtasks-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: true,
  header: {
    headerNew: "Headings.systemTasks",
    headerEdited: "System Tasks",
  },
};

export const settingsGeneralSettingsEmailSmtp = {
  company: "company_name",
  templateEnable: false,
  templateType: 'settingsEmailSmtp',
  tabs: [
    {
      key: "settings-email-smtp",
      tabNumber: 1,
      tabName: "Smtp",
      tabData: <SettingsEmailSMTP />,
      permission: "settings-generalsettings/emailsmtp-read",
    },

    {
      key: "settings-email-smtp",
      tabNumber: 2,
      tabName: "Log",
      tabData: <LogTable logType="smtpLog" />,
      permission: "settings-generalsettings/emailsmtp-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Email Smtp",
    headerEdited: "Email Smtp",
  },
};

export const settingsImport = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {key:"settings-import-settings",
      tabNumber: 1,
      tabName: "Settings",
      tabData: <SettingsOfImport />,
      permission: "settings-importexport/import-read",
    },
    {key:"settings-import-import",
      tabNumber: 2,
      tabName: "Import",
      tabData: <SettingsImport />,
      permission: "settings-importexport/import-read",
    },
    {key:"settings-import-log",
      tabNumber: 3,
      tabName: "Log",
      tabData: <ImportLog />,
      permission: "settings-importexport/import-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Import-Export",
    headerEdited: "Import-Export",
  },
};

export const settingsExport = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    { key:"settings-export-settings",
      tabNumber: 1,
      tabName: "Settings",
      tabData: <SettingsOfExport />,
      permission: "settings-importexport/export-read",
    },
    { key:"settings-export-export",
      tabNumber: 2,
      tabName: "Export",
      tabData: <SettingsExport />,
      permission: "settings-importexport/export-read",
    },
    { key:"settings-export-logs",
      tabNumber: 3,
      tabName: "Log",
      tabData: <LogTable logType="exportSettingsLog" />,
      permission: "settings-importexport/export-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Import-Export",
    headerEdited: "Import-Export",
  },
};

export const settingsBackup = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {key:"settings-backup",
      tabNumber: 1,
      tabName: "Settings",
      tabData: <SettingsOfBackup />,
      permission: "settings-backuprestore/backup-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Backup",
    headerEdited: "Backup",
  },
}

export const settingsRestore = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {key:"settings-restore",
      tabNumber: 1,
      tabName: "Settings",
      tabData: <SettingsOfRestore />,
      permission: "settings-backuprestore/restore-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Restore",
    headerEdited: "Restore",
  },
}

export const newClient_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'client',
  tabs: [
    {
      key:"new-client-general",
      tabNumber: 1,
      tabName: "ClientsNewTabs.general",
      tabData: <NewClientGeneral />,
      permission: "clients-clients/new-general-read",
    },
    {key:"new-client-installations",
      tabNumber: 2,
      tabName: "ClientsNewTabs.installations",
      tabData: <NewClientInstallations />,
      permission: "clients-clients/new-installations-read",
    },
    {key:"new-client-history",
      tabNumber: 3,
      tabName: "ClientsNewTabs.communicationHistory",
      tabData: <NewClientCommunicationHistory />,
      permission: "clients-clients/new-communicationhistory-read",
    },
    {key:"new-client-notes",
      tabNumber: 4,
      tabName: "ClientsNewTabs.notes",
      tabData: <NewClientNotes />,
      permission: "clients-clients/new-notes-read",
    },
    {key:"new-client-emron",
      tabNumber: 5,
      tabName: JSON.parse(localStorage.getItem("company"))?.vatNumber === "800434990" ? "Emron" : "Λοιπά",
      tabData: <NewClientEmron />,
      permission: "clients-clients/new-emron-read",
    },
    {key:"new-client-accounting",
      tabNumber: 6,
      tabName: "ClientsNewTabs.accounting",
      tabData: <NewClientAccounting />,
      permission: "clients-clients/new-accounting-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: true,
  header: {
    headerNew: "Headings.newClient",
    headerEdited: "New Client",
  },
};


export const newSupplier_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'supplier',
  tabs: [
    {
      key:"new-supplier-general",
      tabNumber: 1,
      tabName: "GeneralTab",
      tabData: <NewSupplierGeneral />,
      permission: "suppliers-suppliers/new-general-read",
    },
    {key:"new-supplier-installations",
      tabNumber: 2,
      tabName: "InnerTabs.installations",
      tabData: <NewSupplierInstallations />,
      permission: "suppliers-suppliers/new-installations-read",
    },
    {key:"new-supplier-history",
      tabNumber: 3,
      tabName: "InnerTabs.communicationHistory",
      tabData: <NewSupplierCommunicationHistory />,
      permission: "suppliers-suppliers/new-communicationhistory",
    },
    {key:"new-supplier-accounting",
      tabNumber: 4,
      tabName: "InnerTabs.accounting",
      tabData: <NewSupplierAccounting />,
      permission: "suppliers-suppliers/new-accounting-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: true,
  header: {
    headerNew: "Headers.SupplierNew",
    headerEdited: "Headers.SupplierNew",
  },
}

export const editClient_DP_JSON = (tabKey) => {
  return {
    company: "company_name",
    templateEnable: true,
    templateType: 'editClient',
    tabs: [
      {
        key:"new-client-general",
        tabNumber: 1,
        tabName: "ClientsNewTabs.general",
        tabData: <EditClientGeneral tabKey={tabKey} />,
        permission: "clients-clients/edit-general-read",
      },
      {key:"new-client-installations",
        tabNumber: 2,
        tabName: "ClientsNewTabs.installations",
        tabData: <EditClientInstallations tabKey={tabKey} />,
        permission: "clients-clients/edit-installations-read",
      },
      {key:"new-client-information",
        tabNumber: 3,
        tabName: "ClientsNewTabs.communicationHistory",
        tabData: <EditClientCommunicationHistory tabKey={tabKey} />,
        permission: "clients-clients/edit-communicationhistory-read",
      },
      {key:"new-client-notes",
        tabNumber: 4,
        tabName: "ClientsNewTabs.notes",
        tabData: <EditClientNotes tabKey={tabKey} />,
        permission: "clients-clients/edit-notes-read",
      },
      {key:"new-client-emron",
        tabNumber: 5,
        tabName: JSON.parse(localStorage.getItem("company"))?.vatNumber === "800434990" ? "Emron" : "Λοιπά",
        tabData: <EditClientEmron tabKey={tabKey} />,
        permission: "clients-clients/edit-emron-read",
      },
      {key:"new-client-accounting",
        tabNumber: 6,
        tabName: "ClientsNewTabs.accounting",
        tabData: <EditClientAccounting tabKey={tabKey} />,
        permission: "clients-clients/edit-accounting-read",
      },
      {
        tabNumber: 7,
        tabName: JSON.parse(localStorage.getItem("company"))?.vatNumber === "800434990" ? "Διακανονισμοί" : "Συνδρομές",
        tabData: <EditClientSubscriptions tabKey={tabKey} />,
        permission: "clients-clients/edit-subscriptions-read"
      },
      {
        key: "edit-client-cloud",
        tabNumber: 8,
        tabName: "Αρχεία",
        tabData: <EditClientCloud tabKey={tabKey} />,
        permission: "clients-clients/edit-cloud-read",
      },
      {key:"new-client-log",
        tabNumber: 9,
        tabName: "Log",
        tabData: <ClientsEditLog tabKey={tabKey} />,
        permission: "clients-clients/edit-read",
      },
    ],
    deleteBtn: true,
    saveBtn: true,
    clearForm: true,
    saveandrepeat: false,
    header: {
      headerNew: "Headings.editClient",
      headerEdited: "Edit Client",
    },
  }
}

export const editSupplier_DP_JSON = (tabKey) => {
  return {
    company: "company_name",
    templateEnable: true,
    templateType: 'editSupplier',
    tabs: [
      {
        tabNumber: 1,
        tabName: "GeneralTab",
        tabData: <EditSupplierGeneral tabKey={tabKey} />,
        permission: "suppliers-suppliers/edit-general-read",
      },
      {key:"new-supplier-installations",
        tabNumber: 2,
        tabName: "InnerTabs.installations",
        tabData: <EditSupplierInstallations tabKey={tabKey} />,
        permission: "suppliers-suppliers/edit-installations-read",
      },
      {key:"new-supplier-information",
        tabNumber: 3,
        tabName: "InnerTabs.communicationHistory",
        tabData: <EditSupplierCommunicationHistory tabKey={tabKey} />,
        permission: "suppliers-suppliers/edit-communicationhistory-read",
      },
      {key:"new-supplier-accounting",
        tabNumber: 4,
        tabName: "InnerTabs.accounting",
        tabData: <EditSupplierAccounting tabKey={tabKey} />,
        permission: "suppliers-suppliers/edit-accounting-read",
      },
      {
        key: "edit-supplier-cloud",
        tabNumber: 5,
        tabName: "Αρχεία",
        tabData: <EditSupplierCloud tabKey={tabKey} />,
        permission: "suppliers-suppliers/edit-cloud-read",
      },
      {key:"new-supplier-log",
        tabNumber: 6,
        tabName: "Log",
        tabData: <SuppliersEditLog tabKey={tabKey} />,
        permission: "suppliers-suppliers/edit-read",
      },
    ],
    deleteBtn: true,
    saveBtn: true,
    clearForm: true,
    saveandrepeat: false,
    header: {
      headerNew: "Headers.SupplierEdit",
      headerEdited: "Headers.SupplierEdit",
    },
  }
}

export const clientMovementsNew_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'clientMovements',
  tabs: [
    {key:"client-movements-new-general",
      tabNumber: 1,
      tabName: "ClientsMovementNewTabs.general",
      tabData: <ClientMovementsNew />,
      permission: "clients-clientmovements/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  saveandrepeat: true,
  header: {
    headerNew: "Headings.newClientMovements",
    headerEdited: "New Client Movements",
  },
};

export const editClientMovements_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'editClientMovements',
  tabs: [
    {key:"client-movements-new-general",
      tabNumber: 1,
      tabName: "ClientsMovementNewTabs.general",
      tabData: <EditClientMovements />,
      permission: "clients-clientmovements/edit-read",
    },
    {key:"client-movements-new-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <ClientMovementsEditLog />,
      permission: "clients-clientmovements/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: true,
  saveandrepeat: false,
  header: {
    headerNew: "Headings.editClientMovements",
    headerEdited: "Edit Client Movements",
  },
};

export const supplierMovementsNew_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'supplierMovements',
  tabs: [
    {key:"supplier-movements-new-general",
      tabNumber: 1,
      tabName: "GeneralTab",
      tabData: <SupplierMovementsNew />,
      permission: "suppliers-suppliermovements/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  saveandrepeat: true,
  header: {
    headerNew: "Headers.SupplierMovementNew",
    headerEdited: "Headers.SupplierMovementNew",
  },
}

export const editSupplierMovements_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'editSupplierMovements',
  tabs: [
    {key:"supplier-movements-new-general",
      tabNumber: 1,
      tabName: "GeneralTab",
      tabData: <EditSupplierMovements />,
      permission: "suppliers-suppliermovements/edit-read",
    },
    {key:"supplier-movements-new-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <SupplierMovementsEditLog />,
      permission: "suppliers-suppliermovements/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: true,
  saveandrepeat: false,
  header: {
    headerNew: "Headers.SupplierMovementEdit",
    headerEdited: "Headers.SupplierMovementEdit",
  },
}

export const reportsEmronPayments_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {key:"emron-payments-general",
      tabNumber: 1,
      tabName: "Μηνιαίες Χρεώσεις",
      tabData: <EmronPayments />,
      permission: "clients-reports/emronpayments-read",
    }
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Μηνιαίες Χρεώσεις",
    headerEdited: "Μηνιαίες Χρεώσεις",
  },
}

export const settingsClientsSettings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'clientsSettings',
  tabs: [
    {key:"client-settings-general",
      tabNumber: 1,
      tabName: "ReportsClientsSettingsTabs.general",
      tabData: <ClientsSettings />,
      permission: "clients-settings/clientsettings-read",
    },
    {key:"client-settings-massEmails",
      tabNumber: 2,
      tabName: "ReportsClientsSettingsTabs.massEmail",
      tabData: <p>No information </p>,
      permission: "clients-settings/clientsettings-read",
    },
    {key:"client-settings-log",
      tabNumber: 3,
      tabName: "Log",
      tabData: <ClientSettingsLog />,
      permission: "clients-settings/clientsettings-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Headings.clientsSettings",
    headerEdited: "Clients Settings",
  },
};

export const settingsSuppliersSettings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'suppliersSettings',
  tabs: [
    {key:"supplier-settings-general",
      tabNumber: 1,
      tabName: "GeneralTab",
      tabData: <SuppliersSettings />,
      permission: "suppliers-settings/suppliersettings-read",
    },
    /*{key:"supplier-settings-massEmails",
      tabNumber: 2,
      tabName: "Mass Emails",
      tabData: <p>No information </p>,
      permission: "suppliers-settings/suppliersettings-read",
    },*/
    {key:"supplier-settings-log",
      tabNumber: 3,
      tabName: "Log",
      tabData: <SupplierSettingsLog />,
      permission: "suppliers-settings/suppliersettings-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Headers.SupplierSettings",
    headerEdited: "Headers.SupplierSettings",
  },
}

// Sales
export const salesNew_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'sales',
  tabs: [
    {key:"sales-new-sales",
      tabNumber: 1,
      tabName: "SalesNewTabs.sales",
      tabData: <SalesNew />,
      permission: "sales-sales/new-read"
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: true,
  sendEmailOnSave: true,
  printLayoutDropdown: true,
  printBtn: false,
  convertDocument: false,
  issueCreditDocument: false,
  header: {
    headerNew: "Headings.newSales",
    headerEdited: "New Sales",
  },
};

// Buys
export const buysNew_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'buys',
  tabs: [
    {key:"buys-new-buys",
      tabNumber: 1,
      tabName: "Buys",
      tabData: <BuysNew />,
      permission: "buys-buy/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: true,
  sendEmailOnSave: true,
  printLayoutDropdown: true,
  printBtn: false,
  convertDocument: false,
  issueCreditDocument: false,
  header: {
    headerNew: "Headers.BuysNew",
    headerEdited: "Headers.BuysNew",
  },
};

// Sales
export const salesEdit_DP_JSON = (tabKey) => {
    return {
        company: "company_name",
        templateEnable: false,
        templateType: 'editSales',
        tabs: [
            {key:"sales-new-sales",
                tabNumber: 1,
                tabName: "SalesNewTabs.sales",
                tabData: <ViewSales tabKey={tabKey} />,
                permission: "sales-sales/edit-read",
            },
            {key:"sales-edit-log",
                tabNumber: 2,
                tabName: "Log",
                tabData: <SalesEditLog tabKey={tabKey} />,
                permission: "sales-sales/edit-read",
            },
        ],
        deleteBtn: false,
        saveBtn: false,
        clearForm: false,
        saveandrepeat: false,
        sendEmailOnSave: false,
        printLayoutDropdown: true,
        printBtn: true,
        convertDocument: true,
        issueCreditDocument: true,
        cancelMyDataInvoice: true,
        header: {
            headerNew: "Headings.viewSales",
            headerEdited: "View Sales",
        },
    }
}

// Quotations
export const quotationsNew_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'quotations',
  tabs: [
    {key:"sales-quotations-new",
      tabNumber: 1,
      tabName: "Νέα Προσφορά",
      tabData: <QuotationsNew />,
      permission: "quotations/new-read"
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: true,
  sendEmailOnSave: true,
  printLayoutDropdown: true,
  printBtn: false,
  convertDocument: false,
  issueCreditDocument: false,
  header: {
    headerNew: "Προσφορές",
    headerEdited: "New Quotations",
  },
};

export const quotationsEditTrue_DP_JSON = (tabKey) => {
  return {
    company: "company_name",
    templateEnable: true,
    templateType: 'editQuotations',
    tabs: [
      {
        key: "sales-quotations-edit",
        tabNumber: 1,
        tabName: "Επεξεργασία Προσφοράς",
        tabData: <QuotationsEdit tabKey={tabKey} />,
        permission: "sales-quotations/edit-read"
      },
      {key:"quotations-edit-log",
        tabNumber: 2,
        tabName: "Log",
        tabData: <QuotationsEditLog tabKey={tabKey} />,
        permission: "sales-quotations/edit-read",
      },
    ],
    deleteBtn: false,
    saveBtn: true,
    clearForm: false,
    saveandrepeat: false,
    sendEmailOnSave: true,
    printLayoutDropdown: true,
    printBtn: true,
    convertDocument: false,
    convertQuotation: true,
    issueCreditDocument: false,
    header: {
      headerNew: "Επεξεργασία Προσφοράς",
      headerEdited: "Edit Quotations",
    },
  }
};

// primer AI url
export const primerAiUrlNew_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'primerAiUrl',
  tabs: [
    {key:"primer-ai-url",
      tabNumber: 1,
      tabName: "Δημιουργία URL Primer AI",
      tabData: <AiUrlGenerator />,
      permission: "primer-ai-url/new-read"
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  saveandrepeat: false,
  sendEmailOnSave: false,
  printLayoutDropdown: false,
  printBtn: false,
  convertDocument: false,
  issueCreditDocument: false,
  header: {
    headerNew: "Δημιουργία URL Primer AI"
  }
};

export const buysEditTrue_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editBuys',
  tabs: [
    {key:"buys-edit-buys",
      tabNumber: 1,
      tabName: "Buys",
      tabData: <EditBuys />,
      permission: "buys-buy/edit-read",
    },
    {key:"buys-edit-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <BuysEditLog />,
      permission: "buys-buy/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: false,
  sendEmailOnSave: true,
  printLayoutDropdown: true,
  printBtn: true,
  convertDocument: false,
  issueCreditDocument: false,
  cancelMyDataInvoice: true,
  header: {
    headerNew: "Headers.BuysEdit",
    headerEdited: "Headers.BuysEdit",
  },
};

export const clientPaymentsNew_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'clientPayments',
  tabs: [
    {key:"client-payments-new-general-read",
      tabNumber: 1,
      tabName: "SalesClientPaymentsTabs.general",
      tabData: <ClientPaymentsNew />,
      permission: "sales-clientpayments/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: true,
  sendEmailOnSave: true,
  printLayoutDropdown: true,
  header: {
    headerNew: "Headings.clientPaymentsNew",
    headerEdited: "Client Payments New",
  },
};

export const clientPaymentsEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editClientPayments',
  tabs: [
    {key:"client-payments-new-general-read",
      tabNumber: 1,
      tabName: "SalesClientPaymentsTabs.general",
      tabData: <EditClientPayments />,
      permission: "sales-clientpayments/edit-read",
    },
    {key:"client-payments-new-log-read",
      tabNumber: 2,
      tabName: "Log",
      tabData: <ClientPaymentsEditLog />,
      permission: "sales-clientpayments/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: false,
  printLayoutDropdown: true,
  printBtn: true,
  header: {
    headerNew: "Headings.editClientPayments",
    headerEdited: "Edit Client Payments",
  },
};

export const supplierPaymentsNew_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'supplierPayments',
  tabs: [
    {key:"supplier-payments-new-general-read",
      tabNumber: 1,
      tabName: "GeneralTab",
      tabData: <SupplierPaymentsNew />,
      permission: "buys-supplierpayments/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: true,
  header: {
    headerNew: "Headers.SupplierPaymentNew",
    headerEdited: "Headers.SupplierPaymentEdit",
  },
};

export const supplierPaymentsEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editSupplierPayments',
  tabs: [
    {key:"supplier-payments-new-general-read",
      tabNumber: 1,
      tabName: "GeneralTab",
      tabData: <EditSupplierPayments />,
      permission: "buys-supplierpayments/edit-read",
    },
    {key:"supplier-payments-new-log-read",
      tabNumber: 2,
      tabName: "Log",
      tabData: <SupplierPaymentsEditLog />,
      permission: "buys-supplierpayments/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: false,
  saveandrepeat: false,
  header: {
    headerNew: "Headers.SupplierPaymentEdit",
    headerEdited: "Headers.SupplierPaymentEdit",
  },
};

export const salesMyDataReport_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {key:"send-my-data-report",
      tabNumber: 1,
      tabName: "SalesMyDataTabs.myDataReport",
      tabData: <SalesMydataReport />,
      permission: "sales-mydata/mydatareport-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: true,
  header: {
    headerNew: "Headings.myDataDataReport",
    headerEdited: "MyData Data Report",
  },
};

export const buysMyDataReport_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  tabs: [
    {
      key:"buys-mydata-report",
      tabNumber: 1,
      tabName: "InnerTabs.buysMyData",
      tabData: <BuysMydataReport />,
      permission: "buys-mydata/mydatareport-read",
    },
  ],
  deleteBtn: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Headers.BuysMyData",
    headerEdited: "Headers.BuysMyData",
  },
}

// Cash
export const cashRegistersNew_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'cashRegisters',
  tabs: [
    {key:"cash-register-new-cashRegister",
      tabNumber: 1,
      tabName: "cashRegistersNewTabs.cashRegisters",
      tabData: <CashRegistersNew />,
      permission: "cash-cashregisters/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Headings.newCashRegisters",
    headerEdited: "New Cash Registers",
  },
};

export const editCashRegisters_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editCashRegisters',
  tabs: [
    {key:"cash-register-new-cashRegister",
      tabNumber: 1,
      tabName: "cashRegistersNewTabs.cashRegisters",
      tabData: <EditCashRegisters />,
      permission: "cash-cashregisters/edit-read",
    },
    {key:"cash-register-new-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <CashEditLog />,
      permission: "cash-cashregisters/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Headings.editCashRegisters",
    headerEdited: "Edit Cash Registers",
  },
}

export const bankAccountsNew_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'bankAccounts',
  tabs: [
    {key:"cash-register-bank-accounts-new-register",
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <BankAccountNew />,
      permission: "cash-bankaccounts/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Headings.newBankAccount",
    headerEdited: "New Bank Account",
  },
};

export const editBankAccounts_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editBankAccounts',
  tabs: [
    {key:"cash-register-bank-accounts-new-register",
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <EditBankAccounts />,
      permission: "cash-bankaccounts/edit-read",
    },
    {key:"cash-register-bank-accounts-new-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <BankEditLog />,
      permission: "cash-bankaccounts/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Headings.editBankAccount",
    headerEdited: "Edit Bank Account",
  },
};

export const chequeNew_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'cheques',
  tabs: [
    {
      key: "cheque-new",
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <ChequeNew />,
      permission: "cash-cheques/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Εισαγωγή Επιταγής",
  },
};

export const chequeEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editCheques',
  tabs: [
    {
      key: "cheque-edit",
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <ChequeEdit />,
      permission: "cash-cheques/edit-read",
    },
    {
      key: "cheque-edit-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <ChequeEditLog />,
      permission: "cash-cheques/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Επεξεργασία Επιταγής",
  },
};

export const PosNew_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'POS',
  tabs: [
    {key:"cash-register-pos-new-register",
      tabNumber: 1,
      tabName: "PosNewTabs.registers",
      tabData: <PosNew />,
      permission: "cash-pos/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Headings.newPOS",
    headerEdited: "New POS",
  },
};

export const PosEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editPOS',
  tabs: [
    {key:"cash-register-pos-new-register",
      tabNumber: 1,
      tabName: "PosNewTabs.registers",
      tabData: <EditPos />,
      permission: "cash-pos/edit-read",
    },
    {key:"cash-register-pos-new-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <PosEditLog />,
      permission: "cash-pos/edit-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Headings.editPOS",
    headerEdited: "Edit POS",
  },
};

export const cashAccountingSettings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'cashAccountingSettings',
  tabs: [
    {
      key: "cash-settings-accounting",
      tabNumber: 1,
      tabName: "Λογιστική",
      tabData: <CashSettingsAccounting />,
      permission: "cash-settings/general-generalsettings-read",
    },
    {key:"cash-settings-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <CashSettingsLog />,
      permission: "cash-settings/general-generalsettings-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Λογιστική Ταμειακών",
    headerEdited: "Λογιστική Ταμειακών"
  }
}

export const EmployeeNew_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'newEmployee',
  tabs: [
    {key:"employee-new",
      tabNumber: 1,
      tabName: "EmployeeTabs.New",
      tabData: <NewEmployee />,
      permission: "accounting-employees/new-read",
    },
    {key:"employee-new-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <LogTable logType="employeeLog" />,
      permission: "accounting-employees/new-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Headings.newEmployee",
    headerEdited: "New Employee",
  },
};

export const EmployeeEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editEmployee',
  tabs: [
    {key:"employee-edit",
      tabNumber: 1,
      tabName: "EmployeeTabs.Edit",
      tabData: <EditEmployee />,
      permission: "accounting-employees/edit-read",
    },
    {key:"employee-edit-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <EmployeeEditLog />,
      permission: "accounting-employees/edit-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Headings.editEmployee",
    headerEdited: "Edit Employee",
  },
}

export const AccountingAccountNew_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'newAccountingAccount',
  tabs: [
    {key:"accounting-account-new",
      tabNumber: 1,
      tabName: "AccountingAccountTabs.New",
      tabData: <NewAccountingAccount />,
      permission: "accounting-accountingaccounts/new-general-read",
    },
    {key:"accounting-account-new-mydata",
      tabNumber: 2,
      tabName: "AccountingAccountTabs.NewMyData",
      tabData: <AccountingAccountNewMyData />,
      permission: "accounting-accountingaccounts/new-mydata-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Headings.newAccountingAccount",
    headerEdited: "New Accounting Account",
  },
};

export const AccountingAccountEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editAccountingAccount',
  tabs: [
    {key:"accounting-account-edit",
      tabNumber: 1,
      tabName: "AccountingAccountTabs.Edit",
      tabData: <EditAccountingAccount />,
      permission: "accounting-accountingaccounts/edit-general-read",
    },
    {key:"accounting-account-edit-mydata",
      tabNumber: 2,
      tabName: "AccountingAccountTabs.EditMyData",
      tabData: <AccountingAccountEditMyData />,
      permission: "accounting-accountingaccounts/edit-mydata-read",
    },
    {key:"accounting-account-edit-log",
      tabNumber: 3,
      tabName: "Log",
      tabData: <AccountingAccountsEditLog />,
      permission: "accounting-accountingaccounts/edit-general-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Headings.editAccountingAccount",
    headerEdited: "Edit Accounting Account",
  },
};

export const AccountingRecordNew_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'newAccountingRecord',
  tabs: [
    {key:"accounting-record-new",
      tabNumber: 1,
      tabName: "AccountingRecordTabs.New",
      tabData: <NewAccountingRecord />,
      permission: "accounting-accountingrecords/new-general-read",
    },
      /*
      {key:"accounting-record-new-commercial",
      tabNumber: 2,
      tabName: "AccountingRecordTabs.Commercial",
      tabData: <NewAccountingRecord />,
      permission: "accounting-accountingrecords/new-commercialrecord-read",
    },
       */
  ],
  deleteBtn: false,
  saveBtn: true,
  saveandrepeat: true,
  clearForm: true,
  header: {
    headerNew: "Headings.newAccountingRecord",
    headerEdited: "New Accounting Record",
  },
};

export const AccountingRecordEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editAccountingRecord',
  tabs: [
    {key:"accounting-record-edit",
      tabNumber: 1,
      tabName: "AccountingRecordTabs.Edit",
      tabData: <EditAccountingRecord />,
      permission: "accounting-accountingrecords/edit-general-read",
    },
    {key:"accounting-record-edit-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <AccountingRecordEditLog />,
      permission: "accounting-accountingaccounts/new-general-read",
    },
  ],
  deleteBtn: true,
  saveBtn: true,
  clearForm: true,
  cancelMyDataInvoice: true,
  header: {
    headerNew: "Headings.editAccountingRecord",
    headerEdited: "Edit Accounting Record",
  },
};

export const accountingClosure_DP_JSON = {
  company: "company_name",
  templateEnable: true,
  templateType: 'accountingClosure',
  tabs: [
    {
      key: "accounting-closure",
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <AccountingClosure />,
      permission: "accounting-accountingrecords/closure-read",
    },
  ],
  deleteBtn: false,
  saveBtn: true,
  clearForm: false,
  cancelMyDataInvoice: false,
  header: {
    headerNew: "Κλείσιμο λογαριασμών",
    headerEdited: "Κλείσιμο λογαριασμών",
  },
}

export const salesGeneralSettings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'salesGeneralSettings',
  tabs: [
    {
      tabNumber: 1,
      tabName: "SalesGeneralSettingsTabs.settings",
      tabData: <SalesGeneralSettings />,
      permission: "sales-settings/salesgeneralsettings-read",
    },
    {
      tabNumber: 2,
      tabName: "Ρυθμίσεις Ψηφιακού Πελατολογίου",
      tabData: <DclSettings />,
      permission: "sales-settings/dclsettings-read",
    },
    {
      tabNumber: 3,
      tabName: "Log",
      tabData: <SalesGeneralSettingsLog />,
      permission: "sales-settings/salesgeneralsettings-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Headings.salesGeneralSettings",
    headerEdited: "Sales Settings",
  },
};


export const buysGeneralSettings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'buysGeneralSettings',
  tabs: [
    {
      tabNumber: 1,
      tabName: "InnerTabs.settings",
      tabData: <BuysGeneralSettings />,
      permission: "buys-settings/buygeneralsettings-read"
    },
    /*{
      tabNumber: 2,
      tabName: "InnerTabs.buysEmailSettings",
      tabData: <BuysEmailSettings />,
      permission: "buys-settings/buygeneralsettings-read"
    },*/
    {
      tabNumber: 3,
      tabName: "Log",
      tabData: <BuysGeneralSettingsLog />,
      permission: "buys-settings/buygeneralsettings-read"
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: true,
  header: {
    headerNew: "Headers.BuysSettings",
    headerEdited: "Headers.BuysSettings",
  },
}

export const settingsSubscriptions_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'settingsSubscriptions',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Subscriptions",
      tabData: <SettingsSubscriptions />,
      permission: "settings-generalsettings/subscriptions-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Subscriptions",
    headerEdited: "Subscriptions",
  },
};

export const reportsClientSubscriptions_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'reportsClientSubscriptions',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Εκτύπωση Συνδρομών",
      tabData: <ReportsClientsSubscriptions />,
      permission: "clients-reports/reportsclientsubscriptions-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Συνδρομές Πελατών",
    headerEdited: "Συνδρομές Πελατών",
  },
}

export const newWorkMovement_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'newWorkMovement',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <NewWorkMovement />,
      permission: "payroll-workmovements/new-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Εισαγωγή Κίνησης Εργαζομένου",
    headerEdited: "Εισαγωγή Κίνησης Εργαζομένου",
  },
}

export const editWorkMovement_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editWorkMovement',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <EditWorkMovement />,
      permission: "payroll-workmovements/edit-read",
    }, {
      key:"workMovement-edit-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <WorkMovementEditLog />,
      permission: "accounting-employees/edit-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Επεξεργασία Κίνησης Εργαζομένου",
    headerEdited: "Επεξεργασία Κίνησης Εργαζομένου",
  },
}

export const newWorkPermit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'newWorkPermit',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <NewWorkPermit />,
      permission: "payroll-workpermits/new-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Εισαγωγή Άδειας Εργαζομένου",
    headerEdited: "Εισαγωγή Άδειας Εργαζομένου",
  },
}

export const editWorkPermit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editWorkPermit',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <EditWorkPermit />,
      permission: "payroll-workpermits/edit-read",
    }, {
      key:"workPermit-edit-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <WorkPermitEditLog />,
      permission: "accounting-employees/edit-read",
    },
  ],
  deleteBtn: true,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Επεξεργασία Άδειας Εργαζομένου",
    headerEdited: "Επεξεργασία Άδειας Εργαζομένου",
  },
}

export const payrollSettings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'payrollSettings',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Ρυθμίσεις",
      tabData: <PayrollSettings />,
      permission: "payroll-settings/settings-read",
    },
    {
      tabNumber: 2,
      tabName: "Log",
      tabData: <PayrollSettingsLog />,
      permission: "payroll-settings/settings-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Ρυθμίσεις Μισθοδοσίας",
    headerEdited: "Ρυθμίσεις Μισθοδοσίας",
  },
}

export const prescriptionVisitNew_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: "newVisit",
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <VisitNew />,
      permission: "prescription-visit/new-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Νέα επίσκεψη",
    headerEdited: "Νέα επίσκεψη",
  },
}

export const prescriptionVisitActive_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: "activeVisit",
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <VisitActive />,
      permission: "prescription-visit/active-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: true,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Ενεργή Επίσκεψη",
    headerEdited: "Ενεργή Επίσκεψη",
  },
}

export const prescriptionVisitEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: "editVisit",
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <VisitEdit />,
      permission: "prescription-visit/edit-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Προβολή Επίσκεψης",
    headerEdited: "Προβολή Επίσκεψης",
  },
}

export const prescriptionEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: "editPrescription",
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <PrescriptionEdit />,
      permission: "prescription-prescription/edit-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Προβολή Συνταγής",
    headerEdited: "Προβολή Συνταγής",
  },
}

export const prescriptionReferralEdit_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: "editReferral",
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <ReferralEdit />,
      permission: "prescription-referral/edit-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Προβολή Παραπεμπτικού",
    headerEdited: "Προβολή Παραπεμπτικού",
  },
}

export const prescriptionSettings_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'prescriptionSettings',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Ρυθμίσεις",
      tabData: <PrescriptionSettings />,
      permission: "prescription-settings/settings-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Ρυθμίσεις Συνταγογράφησης",
    headerEdited: "Ρυθμίσεις Συνταγογράφησης",
  },
}

export const editDcl_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editDcl',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <EditDcl />,
      permission: "sales-dcl/edit-read",
    }, {
      key:"dcl-edit-log",
      tabNumber: 2,
      tabName: "Log",
      tabData: <DclEditLog />,
      permission: "sales-dcl/edit-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: false,
  clearForm: false,
  header: {
    headerNew: "Επεξεργασία Κίνησης Ψηφιακού Πελατολογίου",
    headerEdited: "Επεξεργασία Κίνησης Ψηφιακού Πελατολογίου",
  },
}

export const fixedAssetsSettings_DP_JSON = {
    company: "company_name",
    templateEnable: false,
    templateType: 'fixedAssetsSettings',
    tabs: [
        {
            tabNumber: 1,
            tabName: "Γενικά",
            tabData: <FixedAssetsSettings />,
            permission: "fixedassets-settings/settings-read",
        },
        {
            tabNumber: 2,
            tabName: "Log",
            tabData: <FixedAssetsSettingsLog />,
            permission: "fixedassets-settings/settings-read",
        },
    ],
    deleteBtn: false,
    saveandrepeat: false,
    saveBtn: true,
    clearForm: false,
    header: {
        headerNew: "Ρυθμίσεις Παγίων",
        headerEdited: "Ρυθμίσεις Παγίων",
    },
}

export const newFixedAsset_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'newFixedAsset',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <NewFixedAsset/>,
      permission: "fixedassets-fixedassets/new-general-read",
    },
    {
      tabNumber: 2,
      tabName: "Λογιστική",
      tabData: <NewFixedAssetAccounting/>,
      permission: "fixedassets-fixedassets/new-accounting-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Νέο Πάγιο",
    headerEdited: "Νέο Πάγιο",
  },
}

export const editFixedAsset_DP_JSON = {
    company: "company_name",
    templateEnable: false,
    templateType: 'editFixedAsset',
    tabs: [
        {
            tabNumber: 1,
            tabName: "Γενικά",
            tabData: <EditFixedAsset />,
            permission: "fixedassets-fixedassets/edit-general-read",
        },
        {
          tabNumber: 2,
          tabName: "Λογιστική",
          tabData: <EditFixedAssetAccounting />,
          permission: "fixedassets-fixedassets/edit-accounting-read",
        },
        {
            tabNumber: 3,
            tabName: "Log",
            tabData: <EditFixedAssetLog />,
            permission: "fixedassets-fixedassets/edit-read",
        },
    ],
    deleteBtn: true,
    saveandrepeat: false,
    saveBtn: true,
    clearForm: false,
    header: {
        headerNew: "Επεξεργασία Παγίου",
        headerEdited: "Επεξεργασία Παγίου",
    },
}

export const newFixedAssetMovement_DP_JSON = {
    company: "company_name",
    templateEnable: false,
    templateType: 'newFixedAssetMovement',
    tabs: [
        {
            tabNumber: 1,
            tabName: "Γενικά",
            tabData: <NewFixedAssetMovement />,
            permission: "fixedassets-movements/new-read",
        },
    ],
    deleteBtn: false,
    saveandrepeat: false,
    saveBtn: true,
    clearForm: false,
    header: {
        headerNew: "Νέα Κίνηση Παγίων",
        headerEdited: "Νέα Κίνηση Παγίων",
    },
}

export const editFixedAssetMovement_DP_JSON = {
    company: "company_name",
    templateEnable: false,
    templateType: 'editFixedAssetMovement',
    tabs: [
        {
            tabNumber: 1,
            tabName: "Γενικά",
            tabData: <EditFixedAssetMovement />,
            permission: "fixedassets-movements/edit-read",
        },
        {
            tabNumber: 2,
            tabName: "Log",
            tabData: <EditFixedAssetMovementLog />,
            permission: "fixedassets-movements/edit-read",
        },
    ],
    deleteBtn: true,
    saveandrepeat: false,
    saveBtn: true,
    clearForm: false,
    header: {
        headerNew: "Επεξεργασία Κίνησης Παγίων",
        headerEdited: "Επεξεργασία Κίνησης Παγίων",
    },
}

export const newFixedAssetRecord_DP_JSON = {
    company: "company_name",
    templateEnable: false,
    templateType: 'newFixedAssetRecord',
    tabs: [
        {
            tabNumber: 1,
            tabName: "Γενικά",
            tabData: <NewFixedAssetRecord />,
            permission: "fixedassets-records/new-read",
        },
    ],
    deleteBtn: false,
    saveandrepeat: false,
    saveBtn: true,
    clearForm: false,
    header: {
        headerNew: "Νέα Απόσβεση",
        headerEdited: "Νέα Απόσβεση",
    },
}

export const editFixedAssetRecord_DP_JSON = {
    company: "company_name",
    templateEnable: false,
    templateType: 'editFixedAssetRecord',
    tabs: [
        {
            tabNumber: 1,
            tabName: "Γενικά",
            tabData: <EditFixedAssetRecord />,
            permission: "fixedassets-records/edit-read",
        },
        {
            tabNumber: 2,
            tabName: "Log",
            tabData: <EditFixedAssetRecordLog />,
            permission: "fixedassets-records/edit-read",
        },
    ],
    deleteBtn: true,
    saveandrepeat: false,
    saveBtn: true,
    clearForm: false,
    cancelMyDataInvoice: true,
    header: {
        headerNew: "Επεξεργασία Απόσβεσης",
        headerEdited: "Επεξεργασία Απόσβεσης",
    },
}

export const manageCompanies_DP_JSON = {
    company: "company_name",
    templateEnable: false,
    templateType: 'manageCompanies',
    tabs: [
        {
            tabNumber: 1,
            tabName: "Εταιρείες",
            tabData: <ManageCompanies />,
            permission: "custom-companyCreator",
        },
    ],
    deleteBtn: false,
    saveandrepeat: false,
    saveBtn: false,
    clearForm: false,
    header: {
        headerNew: "Διαχείρηση Εταιρειών",
        headerEdited: "Διαχείρηση Εταιρειών",
    },
}

export const newLoan_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'newLoan',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <NewLoan />,
      permission: "cash-loans/new-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Νέο Δάνειο",
  },
}

export const editLoan_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editLoan',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <EditLoan />,
      permission: "cash-loans/edit-read",
    },
    {
      tabNumber: 2,
      tabName: "Log",
      tabData: <EditLoanLog />,
      permission: "cash-loans/edit-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Επεξεργασία Δανείου",
  },
}

export const newCard_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'newCard',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <CardsNew />,
      permission: "cash-cards/new-read",
    },
  ],
  deleteBtn: false,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Νέα Κάρτα",
  },
}

export const editCard_DP_JSON = {
  company: "company_name",
  templateEnable: false,
  templateType: 'editCard',
  tabs: [
    {
      tabNumber: 1,
      tabName: "Γενικά",
      tabData: <CardsEdit />,
      permission: "cash-cards/edit-read",
    },
    {
      tabNumber: 2,
      tabName: "Log",
      tabData: <CardsEditLog />,
      permission: "cash-cards/edit-read",
    },
  ],
  deleteBtn: true,
  saveandrepeat: false,
  saveBtn: true,
  clearForm: false,
  header: {
    headerNew: "Επεξεργασία Κάρτας",
  },
}
